// 综合管理
export default [
    {
      path: '/financeConfig',
      name: 'financeConfig',
      meta: {
        requireAuth: true,
        keepAlive: true
      },
      component: (resolve) => {
        require(['@/views/financeConfig/financeConfig.vue'], resolve)
      }
    },
    {
      path: '/finaceContractConfig',
      name: 'finaceContractConfig',
      meta: {
        requireAuth: true,
        keepAlive: true
      },
      component: (resolve) => {
        require(['@/views/financeConfig/finaceContractConfig.vue'], resolve)
      }
    },
  
  ]
  


// WEBPACK FOOTER //
// ./src/router/financeConfig.js